"use strict";
const notNumbersAndNotSeparatorOrSign = /(?![,.\-+])\D/g; //Not digit and not a symbol -+,.
const allSeparatorsExceptLast = /[.,](?=.*[,.])/g;
// returns number as it should be, without any formatting and stuff, 1,234.55 -> 1234.55 and 1.234,55 -> 1234.55
String.prototype.toStrippedNumberString = function () {
    return this.replace(notNumbersAndNotSeparatorOrSign, "").replace(allSeparatorsExceptLast, "").replace(",", ".");
};
//# sourceMappingURL=StringExtensions.js.map